/**
 * ./exercise8/Exercise8Summary.js
 * 
 * This module is similar with previous exercises. 
 * 
 */

import React, { useEffect, useState } from 'react';
import '../exercise1/Exercise1Summary.css';
import { useNavigate, useLocation } from 'react-router-dom';
import confettiSvg from '../components/icons/Confetti.svg';
import homeIcon from '../components/icons/Home.svg';
import { updateUserProgress } from '../utility';

// Import necessary Chart.js components
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

// Register chart components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const Exercise8Summary = () => {
  const [showConfetti, setShowConfetti] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const comprehensionAccuracy = location.state?.comprehensionAccuracy || 0;
  const memoryAccuracy = location.state?.memoryAccuracy || 0;
  const levelSelection = location.state?.levelSelection || 2; // ✅ Default to 2 if not found

  // Automatically hide the confetti after animation
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowConfetti(false);
    }, 4000); // Match this to the animation duration
    return () => clearTimeout(timer);
  }, [comprehensionAccuracy, memoryAccuracy, levelSelection]);

  const handleNextSection = () => {
    navigate('/exercise8intro'); // ✅ Advances to Exercise 9
  };

  return (
    <div className="exercise-summary-container">
      {showConfetti && (
        <div className="confetti-container">
          <img
            src={confettiSvg}
            alt="Confetti"
            className="confetti-animation"
          />
        </div>
      )}

      <h1>Congratulations on completing level {levelSelection}!</h1>
      <p>
        You have improved your reading comprehension speed by completing this exercise. 
        As you level up, you’ll absorb exponentially more information in less time!
      </p>

      <div className="improvement-section">
        <div className="improvement-text">
          <p>Your Improvement: Reading Comprehension & Memory</p>
          <p><strong>You reached {comprehensionAccuracy.toFixed(1)}% accuracy in comprehension!</strong></p>
          <p><strong>You reached {memoryAccuracy.toFixed(1)}% accuracy in memory!</strong></p>
        </div>
      </div>

      {/* ✅ "Click below to advance to the next level" Section */}
      <div className="advance-section">
        <p className="advance-text">Click below to advance to the next level.</p>
        <button className="next-button" onClick={handleNextSection}>
          Next Level
        </button>
      </div>

      <div className="bottom-buttons">
        <button className="home-button" onClick={() => navigate("/")}>
          <img src={homeIcon} alt="Home" className="home-icon" />
        </button>
      </div>
    </div>
  );
};

export default Exercise8Summary;
